module.exports = __webpack_public_path__ + "static/media/viktorai.b6717112.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/viktorai.webp
// module id = 816
// module chunks = 0